import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon } from 'lucide-react';
const trust = ['Descarga inmediata', 'Garantía 07 días', 'Sin suscripciones'];
export function Hero() {
  return <section id="hero" className="relative w-full scroll-mt-16 overflow-hidden bg-cream" data-id="element-92" data-mp="9k0f38zo2hq6">
      <div className="leaf-watermark pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-93" data-mp="4m8m0bnacpke" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-5 py-12 sm:px-6 lg:grid-cols-[58%_42%] lg:gap-12 lg:py-16" data-id="element-94" data-mp="12a0n3gpgsax9">
        {/* Mockup — first on mobile */}
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1],
        delay: 0.08
      }} className="order-1 flex flex-col items-center lg:order-2" data-id="element-95" data-mp="sbb39ie0cged">
          <p className="mb-3 text-sm font-semibold uppercase tracking-widest text-gold line-through decoration-2" data-id="element-96" data-mp="3cz5to748dry8">
            Valor total: $238 USD
          </p>

          <div className="relative w-full max-w-md" data-id="element-97" data-mp="3j9tzsvxzjik8">
            <img src="https://cdn.magicpatterns.com/uploads/5oHx76ZLhegkVXSCRWfyYT/Portada_GENERAL.jpg" alt="El Método de Vaciado Biológico junto a sus tres bonos digitales" className="w-full rounded-2xl shadow-[0_24px_60px_rgba(26,60,46,0.28)]" width={1376} height={768} data-id="element-98" data-mp="3o7c0y05rgtho" />
            <div className="absolute -bottom-4 right-2 rotate-[-3deg] rounded-xl bg-coral px-4 py-2 text-sm font-extrabold text-white shadow-lg sm:text-base" data-id="element-99" data-mp="3ebipyl7ox820">
              HOY SOLO $9.99 USD
            </div>
          </div>

          <p className="mt-8 flex items-center gap-2 text-sm font-medium text-warmgray" data-id="element-100" data-mp="2qk3kijkmaamj">
            <LockIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-101" data-mp="2viy25i6ult52" />
            Compra 100% segura
          </p>
        </motion.div>

        {/* Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1]
      }} className="order-2 lg:order-1" data-id="element-102" data-mp="2hjowvdk6kjfv">
          <span className="inline-flex rounded-full border border-gold px-3.5 py-1 text-[12px] font-semibold text-forest" data-id="element-103" data-mp="nbbev44vul7x">
            Protocolo Natural para Adultos 40+
          </span>

          <h1 className="mt-5 text-[34px] font-bold leading-[1.05] tracking-tight text-charcoal lg:text-[52px]" data-id="element-104" data-mp="i9vpizvo9sjq">
            Tu Cuerpo Lleva Años Siendo Saqueado.
          </h1>

          <h2 className="mt-4 text-[20px] font-semibold leading-snug text-forest lg:text-[26px]" data-id="element-105" data-mp="1b04b71pf2v32">
            Recupera Tu Energía, Desinflámate y Elimina los Antojos en 21 Días — Sin Fármacos.
          </h2>

          <p className="mt-4 max-w-xl text-base font-normal leading-relaxed text-warmgray" data-id="element-106" data-mp="114suweyd1ft7">
            El Método de Vaciado Biológico: el protocolo natural que miles de adultos de 40+ ya están
            aplicando.
          </p>

          <ul className="mt-6 flex flex-wrap gap-x-5 gap-y-2" data-id="element-107" data-mp="3hrlkwjixk99i">
            {trust.map(item => <li key={item} className="flex items-center gap-1.5 text-[13px] font-semibold text-forest" data-id="element-108" data-mp="1x9b42xkwqvaz">
                <CheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-109" data-mp="21awemc9yyxi0" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}